var render = function () {
  var _vm$me, _vm$me2;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c(_vm.template, {
    tag: "component"
  }, [_c('div', [_c('div', {
    staticClass: "tit-wrap tit-wrap--unberline"
  }, [_c('h2', {
    staticClass: "tit"
  }, [_vm._v("캐시선물하기")])]), _c('v-divider', {
    staticClass: "d-md-none"
  }), _c('div', {
    staticClass: "py-20px pt-md-0px pb-md-40px text-center"
  }, [_c('div', {
    staticClass: "tit tit--xs"
  }, [_c('b', {
    staticClass: "black--text"
  }, [_vm._v(_vm._s((_vm$me = _vm.me) === null || _vm$me === void 0 ? void 0 : _vm$me.name))]), _vm._v("님의 나누리 캐시")]), _c('div', {
    staticClass: "mt-1"
  }, [_c('b', {
    staticClass: "tit tit--lg primary--text font-weight-bold"
  }, [_vm._v(_vm._s(parseInt(+((_vm$me2 = _vm.me) === null || _vm$me2 === void 0 ? void 0 : _vm$me2.cash) || 0).format()))]), _vm._v(" 원")])]), _c('v-divider'), _c('div', {
    staticClass: "pt-20px pt-md-30px"
  }, [_c('v-responsive', {
    staticClass: "mx-auto",
    attrs: {
      "width": "100%",
      "max-width": "400"
    }
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "mb-10px"
  }, [_c('b', [_vm._v("보내는 금액")])]), _c('v-text-field', {
    staticClass: "w-100",
    attrs: {
      "placeholder": "보내는 금액",
      "persistent-placeholder": "",
      "suffix": "원",
      "outlined": "",
      "hide-details": ""
    },
    on: {
      "input": function input($event) {
        return _vm.comma(_vm.gift.amount);
      }
    },
    model: {
      value: _vm.gift.amount,
      callback: function callback($$v) {
        _vm.$set(_vm.gift, "amount", $$v);
      },
      expression: "gift.amount"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-row', {
    staticClass: "row--x-small"
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('b', [_vm._v("받는사람정보")])]), _c('v-spacer')], 1), _c('v-row', {
    staticClass: "row--medium mt-6px"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "연락처",
      "persistent-placeholder": "",
      "outlined": "",
      "hide-details": ""
    },
    model: {
      value: _vm.gift.receiver.phone,
      callback: function callback($$v) {
        _vm.$set(_vm.gift.receiver, "phone", $$v);
      },
      expression: "gift.receiver.phone"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "secondary",
      "x-large": "",
      "block": ""
    },
    on: {
      "click": _vm.give
    }
  }, [_vm._v("캐시선물하기")])], 1)], 1)], 1)], 1)], 1)], 1)], 1), _c('member-dialog', {
    ref: "memberDialog",
    attrs: {
      "me": _vm.me
    },
    on: {
      "input": function input(member) {
        return _vm.gift.receiver = member;
      }
    }
  }), _c('give-dialog', {
    ref: "giveDialog",
    on: {
      "init": function init(member) {
        return _vm.recentUserFilter(member);
      }
    },
    model: {
      value: _vm.gift,
      callback: function callback($$v) {
        _vm.gift = $$v;
      },
      expression: "gift"
    }
  }), _c('login-dialog', {
    ref: "loginDialog"
  }), _c('kcp-cert', {
    ref: "kcpCert"
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }